module.exports = __webpack_public_path__ + "06ba69171a8a0763244e6d8f3b51788c.pdf";